import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import SellerSidebar from "./common/SellerSidebar";
import { FaTrash } from "react-icons/fa";
import EmailSentInvitation from "../pages/common/EmployeRole/EmailSentInvitation";
import NumberSentInvitation from "../pages/common/EmployeRole/NumberSentInvitation";
import QuickSentInvitation from "../pages/common/EmployeRole/QuickSentInvitation";
import { organizationDetail } from "../Context/SelectedOrganization";

export default function EmployeeInvitation() {
  const [activeTab, setActiveTab] = useState("email");
  const { organizationData } = useContext(organizationDetail);

  return (
    <div className="all_suport_bg manages_top">
      <section className="ser_v_araeea profiles">
        <div className="container">
          <div className="bradcams">
            <span className="bothss">
              <Link to="">Dashboard</Link>
              <img src="/images/brd_rowwo.png" alt="" /> Employee
              <img src="/images/brd_rowwo.png" alt="" /> Add Organization Member
            </span>
          </div>

          <div className="row">
            <div className="col-lg-3 mb_view_hide">
              <SellerSidebar />
            </div>

            <div className="col-lg-9 order-list">
              <h4 style={{ fontWeight: "600" }}>Add Organization Member</h4>

              {/* Tabs */}

              <div className="invitation-tab">
                <p>
                  Members refer to people who work in your department , company
                  ,or organisation.
                </p>
                <div className="invitation-tabs-btn">
                  <button
                    className={activeTab === "email" ? "active" : ""}
                    onClick={() => setActiveTab("email")}
                  >
                    Email
                  </button>
                  <button
                    className={activeTab === "phone" ? "active" : ""}
                    onClick={() => setActiveTab("phone")}
                  >
                    Phone
                  </button>
                  <button
                    className={activeTab === "quick" ? "active" : ""}
                    onClick={() => setActiveTab("quick")}
                  >
                    Quick Invitation
                  </button>
                </div>
              </div>

              {/* Email Tab */}
              {activeTab === "email" && (
                <EmailSentInvitation organizationData={organizationData} />
              )}

              {/* Phone Tab */}
              {activeTab === "phone" && <NumberSentInvitation />}

              {/* Quick Invitation */}
              {activeTab === "quick" && <QuickSentInvitation />}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
